import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import TextTruncate from 'rebook/apps/base/components/TextTruncate';

import styles from './style.scss';


const BookDetailFact = ({ facts }) => {
  return facts && (
    <div className="billetContainer">
      <div className={styles.box}>
        <div className={styles.container}>
          <h2>Интересные факты</h2>
        </div>
        <TextTruncate>
          {ReactHtmlParser(facts)}
        </TextTruncate>
      </div>
    </div>
  );
};

BookDetailFact.propTypes = {
  facts: PropTypes.string.isRequired,
};

export default BookDetailFact;
